import * as React from "react";


import projectsIcon from "./static/img/projects-icon.svg";
import ammountIcon from "./static/img/ammount-icon.png";
import distributedIcon from "./static/img/distributed.png";
import undistributed from "./static/img/undistributed.png";
import {Box, Grid, Stack} from "@mui/material";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Api, {APIs} from "../../../../Api";


import "./static/badge.css";
import MidTable from "./MidTable";

interface IProps {
    optionIndex?: number
    height: number
}

const StatsTablePC = (props: IProps) => {
    const {optionIndex} = props
    const params = useSelector((state: any) => state.dashboard)
    const cmpParams = useSelector((state: any) => state.compare)
    // const [damages, setDamages] = useState(0)
    // const [need, setNeed] = useState(0)
    const [data, setData] = useState<any>(null)
    const [projectParams, setProjectParams] = useState<string>("")
    const [signedProjectPercentage, setSignedProjectPercentage] = useState<number>(0)
    // const rating_values = ['Satisfactory', 'Partially satisfactory', 'Problematic']
    const category_values = ['signed', 'pipeline', 'potential', 'total', 'damage_need', "potential_ead"]
    const [totalDisbursement, setTotalDisbursement] = useState<number>(2815.18)
    // const project_types = ["PSDP", "NONPSDP"]
    useEffect(() => {
        const qParams = Object.assign({}, params)
        const {type, options} = cmpParams
        if (optionIndex) {
            qParams[type] = options[optionIndex - 1]
        }
        Api.get(APIs.MoPD_PORTFOLIO, qParams).then((payload) => {
            if (payload) {
                // console.log("portfolio", payload)
                // setData(payload)
                const data: any = {}
                category_values.forEach((val) => {
                    data[val] = payload.data.find((info: any) => info["category"] === val) || {
                        "category": val,
                        "no_of_project": 0,
                        "disbursed": 0,
                        "undisbursed": 0,
                        "amount": 0,
                        withdrawal_amount: 0.
                    }

                })
                setData(data)
                // console.log(data)
                setSignedProjectPercentage(parseFloat((data["signed"]["amount"] / data["total"]["amount"] * 100).toFixed(2)))
                setTotalDisbursement(payload.total_disbursement)
            }
        });
        let p = "";
        for (let key in qParams) {
            p += `&${key}=${qParams[key]}`
        }

        setProjectParams(p)
    }, [params, cmpParams]);
    // const problematicInfoHeight = 55;
    // const statsTableHeight = 365;
    // console.log("paper height", props.height)
    const imgHeight = "16px";
    return (
        <Box sx={{
            height: (props.height < 400 ? 500 : props.height - 20),
            overflowY: "auto",
            width: "100%",
            display: "block"
        }}>
            {/*------Header Box---------*/}
            <Box sx={{flexGrow: 1, height: "15%"}} className="tab-grayholder">
                <Grid container sx={{p: 2, height: "100%"}}>
                    <Grid item xs={2} sx={{height: "100%"}}>
                        <div className={"header-container"} style={{width: "100%", height: "100%"}}>
                            {/*<img height={"20px"} alt="Projects icon" src={projectsIcon}/><br/>*/}
                            {/*<p className="text">NO. OF PROJECT</p>*/}
                        </div>
                    </Grid>
                    <Grid item xs={2.5} sx={{height: "100%"}}>
                        <div className={"header-container"} style={{width: "100%", height: "100%"}}>
                            <span><img height={imgHeight} alt="Projects icon" src={projectsIcon}/>
                                <p className="header-text">PROJECTS</p></span>
                        </div>
                    </Grid>
                    <Grid item xs={2.5} sx={{height: "100%"}}>
                        <div className={"header-container"} style={{width: "100%", height: "100%"}}>
                            <span><img height={imgHeight} alt="Projects icon" src={ammountIcon}/>
                                <p className="header-text">AMOUNT</p></span>
                        </div>
                    </Grid>
                    <Grid item xs={2.5} sx={{height: "100%"}}>
                        <div className={"header-container"} style={{width: "100%", height: "100%"}}>
                            <span><img height={imgHeight} alt="Projects icon" src={distributedIcon}/>
                                <p className="header-text">DISBURSED</p></span>
                        </div>
                    </Grid>
                    <Grid item xs={2.5} sx={{height: "100%"}}>
                        <div className={"header-container"} style={{width: "100%", height: "100%"}}>
                            <span><img height={imgHeight} alt="Projects icon" src={undistributed}/>
                                <p className="header-text">EXPENDITURE</p></span>
                        </div>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{flexGrow: 1, height: "70%", display: "block", alignItem: "stretch"}}>
                <Grid container sx={{p: 0, height: "100%"}}>
                    <Grid item xs={2} className={"category-box"}>
                        {/*<div className="category">CATEGORY</div>*/}
                        <div className="badgholder">

                            <div className="damagesbadge">
                                <div className="dmgh2">DAMAGES</div>
                                <div className="dmgh1">{data && data["damage_need"]["damage"].toLocaleString()}</div>
                            </div>

                            <div className="lossbadge">
                                <div className="lossh1">{data && data["damage_need"]["loss"].toLocaleString()}</div>

                            </div>


                            <div className="needbadge">
                                <div className="needh2">NEED</div>
                                <div className="needh1">{data && data["damage_need"]["need"].toLocaleString()}</div>
                                <div className="needh3">$(Million)</div>
                            </div>

                        </div>
                    </Grid>
                    <Grid item xs={10} sx={{height: "100%", p: 1}}>
                        <MidTable data={data} totalDisbursment={totalDisbursement}  projectParams={projectParams}/>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{flexGrow: 1, pt: 1, height: "5%"}}>
                <Stack>
                    <Box>
                        <h5 className="text-center text-danger">
                            {signedProjectPercentage}% OF THE TOTAL PORTFOLIO IS SIGNED
                        </h5>
                    </Box>
                    <Box sx={{px: 7, py: 0}}>
                        <div className="progress">
                            <div className="progress-bar bg-danger progress-bar-striped" role="progressbar"
                                 style={{width: signedProjectPercentage + "%"}}>{signedProjectPercentage}%
                            </div>
                        </div>
                    </Box>
                </Stack>
            </Box>


        </Box>

    );
};
export default StatsTablePC
